import { Context } from '@leverege/plugin';
import { ringTag } from "../../util/Interface.js";
import { amplitudeRingTagTrackEvent, getRingTagEventSource } from "../../../recovrGeneric/tracking/AmplitudeRingTagTrackingEvent.js";
function isRingableTag(item) {
  switch (item?.type) {
    case 'tag':
      return item.data?.data?.commands?.ring?.state !== 'waitingForDetection';
    case 'key':
    case 'assetTags':
      return item.data?.data?.tag && item.data.data.tag.data?.commands?.ring?.state !== 'waitingForDetection';
    default:
      return false;
  }
}
export default {
  id: 'recovr.tag.Ring',
  name: 'Ring Tag',
  layout: {
    sort: 'z.ring.ring',
    sectionName: 'Ring'
  },
  matches: [{
    use: ['contextMenu', 'mobileActionBar'],
    path: ['tag', 'location.tags', 'company.tags', 'company.locations.tags', 'organization.companies.tags', 'organization.companies.locations.tags', 'key', 'location.keys', 'company.keys', 'company.locations.keys', 'assetTags', 'location.assetsTags', 'company.assetsTags', 'company.locations.assetsTags', 'organization.companies.assetsTags', 'organization.companies.locations.assetsTags'],
    objectType: ['tag', 'key', 'assetTags']
  }, {
    client: 'MapBoxRolloverSelectionPointer',
    use: ['contextMenu', 'mobileActionBar']
  }],
  handles: cxt => {
    const targets = Context.getTargets(cxt);
    if (targets.length === 1 && isRingableTag(targets[0])) {
      return true;
    }
    return false;
  },
  appearance: ({
    context
  }) => {
    const name = 'Ring Tag';
    return {
      name,
      icon: 'fa fa-bell'
    };
  },
  perform: data => {
    const {
      context
    } = data;
    const targets = Context.getTargets(context);
    const reloadData = context?.clientProps?.reloadData;
    const tag = targets[0].type === 'tag' ? targets[0].data : targets[0].data.data.tag;
    ringTag({
      systemId: tag.systemId,
      orgId: tag.data.organization?.id,
      companyId: tag.data.company?.id,
      locationId: tag.data.location?.id,
      deviceId: tag.id
    }, reloadData);
    const eventSource = getRingTagEventSource(context.client);
    amplitudeRingTagTrackEvent(eventSource, 'ring');
  }
};